export default __webpack_public_path__ + "static/media/500.1937c132.png";